import {
  withUser,
  UserProps,
} from "@customer-tools-web/component-authentication";
import * as React from "react";
import { LoadableComponent } from "react-loadable";
import { withRouter, RouteComponentProps } from "react-router";

import { ROUTE_URL, URL_PREFIX } from "../common/const";

type Props = UserProps & RouteComponentProps;

export default function (
  ComposedComponent:
    | (React.ComponentClass<any, any> & LoadableComponent)
    | (React.FC<any> & LoadableComponent)
) {
  const PermissionsGuard: React.FC<Props> = (props: Props) => {
    React.useEffect(() => {
      const isAnnouncementList: boolean = props?.location?.pathname?.includes(
        ROUTE_URL.announcements.root
      );
      const isCreateAnnouncement: boolean = props?.location?.pathname?.includes(
        ROUTE_URL.announcements.create
      );
      const isEditAnnouncement: boolean = props?.location?.pathname?.includes(
        ROUTE_URL.announcements.edit
      );
      if (
        (isCreateAnnouncement &&
          !props?.user?.permissions?.announcement?.canManageAnnouncement) ||
        (isEditAnnouncement &&
          !props?.user?.permissions?.announcement?.canViewManageAnnouncement)
      ) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      } else if (
        isAnnouncementList &&
        !props?.user?.permissions?.announcement?.canViewManageAnnouncement
      ) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, [props.user?.permissions]);

    return <ComposedComponent {...props} />;
  };

  return withUser(withRouter(PermissionsGuard));
}
